import 'angular';

import { downgradeInjectable } from '@angular/upgrade/static';

import { BillerService } from './biller.service';

angular.module('app-lite.biller', [])
  .service('billerApi', downgradeInjectable(BillerService));